import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { AuthLayout } from "@/components/layouts/auth-layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "../hooks/use-auth";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    const result = await login({ email, password });
    setSubmitting(false);
    if (!result.success) {
      toast.error(result.error || "Sign in failed");
      return;
    }
    // AuthContext refreshes the user; navigate to schedules (or change-pw if flag set).
    navigate("/schedules", { replace: true });
  };

  return (
    <AuthLayout>
      <div className="bg-surface border border-border-subtle rounded-lg p-6">
        <h1 className="text-lg font-semibold text-white">Sign in</h1>
        <p className="text-xs text-text-muted mt-1 mb-5">
          Class scheduling for career & tech ed
        </p>
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3.5">
            <Label htmlFor="login-email">Email</Label>
            <Input
              id="login-email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="email-input"
            />
          </div>
          <div className="mb-2">
            <Label htmlFor="login-password">Password</Label>
            <Input
              id="login-password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="password-input"
            />
          </div>
          <div className="text-right mb-4.5 mt-2">
            <Link
              to="/change-password"
              className="text-xs text-blue-400 hover:text-blue-300"
            >
              Forgot password?
            </Link>
          </div>
          <Button
            type="submit"
            className="w-full"
            isLoading={submitting}
            data-testid="submit-button"
          >
            Sign in
          </Button>
        </form>
      </div>
    </AuthLayout>
  );
}
